<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/blocks-builder'), disabled: true}
   ]">
    </Breadcrumbs>

    <div class="row">
      <div class="col-12">
        <label class="form-label">
          {{ $t('iframe.blocks_builder.select_block_type') }}
        </label>
        <multiselect
          id="flow-multiselect"
          v-model="selectedBlockType"
          :options="pageTypes"
          track-by="id"
          :custom-label="val => $t(`iframe.page_types.${val.type}`)"
          :placeholder="$t('iframe.blocks_builder.select_block_type')"
          :allow-empty="true"
          :multiple="false"
        >
          <template slot="clear">
            <span class="multiselect__clear"
                  v-if="selectedBlockType !== null"
                  @mousedown.prevent.stop="selectedBlockType = null"
            />
          </template>
        </multiselect>
      </div>
    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <InfoBlocksTable
        v-if="selectedBlockType.type === 'info_page'"
        ref="iframeBlockIntroTable"
        :writeEntities="writeEntities"
      />

    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <NoiseBlocksTable
        v-if="selectedBlockType.type === 'noise_test_page'"
        ref="iframeBlockNoiseTable"
        :writeEntities="writeEntities"
      />

    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <ContactBlocksTable
        v-if="selectedBlockType.type === 'contact_page'"
        ref="iframeContactBlockTable"
        :writeEntities="writeEntities"
      />

    </div>
    <div class="mt-4" v-if="selectedBlockType">
      <ThanksBlocksTable
        v-if="selectedBlockType.type === 'thanks_page'"
        ref="iframeBlockThanksTable"
        :writeEntities="writeEntities"
      />

    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <TonalTest
        v-if="selectedBlockType.type === 'tonal_test_page'"
        ref="iframeTonalTest"
        :writeEntities="writeEntities"
      />
    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <QuestionnaireBlocksTable
        v-if="selectedBlockType.type === 'questionnaire_page'"
        ref="iframeQuestionnaireTable"
        :writeEntities="writeEntities"
      />
    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <UserInfoBlocksTable
        v-if="selectedBlockType.type === 'user_info_page'"
        ref="iframeUserInfoTable"
        :writeEntities="writeEntities"
      />
    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <BiosignalsBlocksTable
        v-if="selectedBlockType.type === 'biosignals_scan_test_page'"
        ref="iframeBiosignalsPagesTable"
        :writeEntities="writeEntities"
      />
    </div>

    <div class="mt-4" v-if="selectedBlockType">
      <AnamneseBlocksTable
        v-if="selectedBlockType.type === 'anamnese_page'"
        ref="iframeAnamnesePagesTable"
        :writeEntities="writeEntities"
      />
    </div>

  </div>
</template>

<script>
import Searchable from "@/components/common/Searchable";
import Breadcrumbs from "@/components/common/Breadcrumbs";

import Multiselect from 'vue-multiselect'
import {mapState} from "vuex";
import InfoBlocksTable from "@/components/iframe/blocks-builder/info/InfoBlocksTable";
import ThanksBlocksTable from "@/components/iframe/blocks-builder/thanks/ThanksBlocksTable";
import NoiseBlocksTable from "@/components/iframe/blocks-builder/noise/NoiseBlocksTable";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import ContactBlocksTable from "@/components/iframe/blocks-builder/contact/ContactBlocksTable";
import TonalTest from "@/components/iframe/blocks-builder/tonal/TonalTest";
import QuestionnaireBlocksTable from "@/components/iframe/blocks-builder/questionnaire/QuestionnaireBlocksTable";
import UserInfoBlocksTable from "@/components/iframe/blocks-builder/user-info/UserInfoBlocksTable";
import BiosignalsBlocksTable from '@/components/iframe/blocks-builder/biosignals/BiosignalsBlocksTable.vue';
import AnamneseBlocksTable from '@/components/iframe/blocks-builder/anamnese/AnamneseBlocksTable.vue';
export default {
  components: {
    AnamneseBlocksTable,
    BiosignalsBlocksTable,
    UserInfoBlocksTable,
    QuestionnaireBlocksTable,
    ContactBlocksTable, FadeTransition, InfoBlocksTable, NoiseBlocksTable, ThanksBlocksTable, Breadcrumbs, Searchable, Multiselect, TonalTest},
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedBlockType: null,
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      'pageTypes': (state) => state.iframe.pageTypes,
    }),
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
      //return this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
    },
    flowPermissions: function () {
      return this.iframeService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === 100)
    },
    entities: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        return this.iframeService.entities
      }
      return null
    },
    writeEntities: function () {
      return this.entities.filter(entity => this.flowPermissions.some(permission => permission.entity_id === null || permission.entity_id === entity.id)) || []
    }
  },
}
</script>

<style scoped>

</style>
